import React, { useState } from 'react';

interface SignupScreenProps {
  loading: boolean;
  onSubmit: (form: { name: string; email: string; phone: string; password: string; referralCode?: string }) => void;
  onLogin: () => void;
}

export const SignupScreen: React.FC<SignupScreenProps> = ({ loading, onSubmit, onLogin }) => {
  const [form, setForm] = useState({ name: '', email: '', phone: '', password: '', referralCode: '' });

  const handleFieldChange = (key: string, val: string) => {
    setForm((prev) => ({ ...prev, [key]: val }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(form);
  };

  return (
    <div className="pwa-auth-container">
      <h1 className="pwa-auth-title">REGISTER</h1>
      <p className="pwa-auth-subtitle">Create your player account to get started</p>

      <form onSubmit={handleSubmit}>
        <div className="pwa-auth-field">
          <label className="pwa-auth-label">NAME</label>
          <input
            type="text"
            className="pwa-auth-input"
            value={form.name}
            onChange={(e) => handleFieldChange('name', e.target.value)}
            placeholder="Enter your name"
            required
          />
        </div>

        <div className="pwa-auth-field">
          <label className="pwa-auth-label">EMAIL</label>
          <input
            type="email"
            className="pwa-auth-input"
            value={form.email}
            onChange={(e) => handleFieldChange('email', e.target.value)}
            placeholder="Enter email address"
            autoCapitalize="none"
            required
          />
        </div>

        <div className="pwa-auth-field">
          <label className="pwa-auth-label">PHONE NUMBER (FOR OTP VERIFICATION)</label>
          <input
            type="tel"
            className="pwa-auth-input"
            value={form.phone}
            onChange={(e) => handleFieldChange('phone', e.target.value)}
            placeholder="e.g. +12345"
            required
          />
        </div>

        <div className="pwa-auth-field">
          <label className="pwa-auth-label">PASSWORD</label>
          <input
            type="password"
            className="pwa-auth-input"
            value={form.password}
            onChange={(e) => handleFieldChange('password', e.target.value)}
            placeholder="At least 6 characters"
            autoCapitalize="none"
            required
          />
        </div>

        <div className="pwa-auth-field">
          <label className="pwa-auth-label">REFERRAL CODE (OPTIONAL)</label>
          <input
            type="text"
            className="pwa-auth-input"
            value={form.referralCode}
            onChange={(e) => handleFieldChange('referralCode', e.target.value)}
            placeholder="Enter referral code (e.g. REF-X7K9P2)"
            style={{ textTransform: 'uppercase' }}
          />
        </div>

        <button type="submit" disabled={loading} className="pwa-primary-btn">
          {loading ? 'REGISTERING...' : 'COMPLETE SIGNUP'}
        </button>

        <button type="button" onClick={onLogin} className="pwa-secondary-btn">
          BACK TO LOGIN
        </button>
      </form>
    </div>
  );
};
